"use strict";
exports.__esModule = true;
exports.smartYup = exports.HSchema = void 0;
var yup = require("yup");
var services_1 = require("../services");
var SmartYupClass = /** @class */ (function () {
    function SmartYupClass() {
        this.yup = yup;
    }
    SmartYupClass.prototype.stringRequired = function (message) {
        return yup.string().required(message || "This field is required");
    };
    SmartYupClass.prototype.emailRequired = function (message) {
        return yup
            .string()
            .email("Email must be valid")
            .required(message || "This field is required");
    };
    SmartYupClass.prototype.phoneRequired = function (message) {
        return yup
            .string()
            .matches(/^\d{10}$/, "Enter 10 Digit")
            .required(message || "This field is required");
    };
    SmartYupClass.prototype.stringNumberRequired = function (message) {
        return yup
            .string()
            .matches(/^\d$/, "Enter Digit only")
            .required(message || "This field is required");
    };
    SmartYupClass.prototype.numberRequired = function (message) {
        return yup
            .number()
            .typeError("Enter valid number")
            .required(message || "This field is required");
    };
    SmartYupClass.prototype.url = function (message) {
        return yup
            .string()
            .matches(/((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/, message || "Enter correct URL");
    };
    SmartYupClass.prototype.number = function () {
        return yup.number().typeError("Enter valid number");
    };
    SmartYupClass.prototype.percentage = function (message) {
        return yup
            .number()
            .min(0, "Percentage must be at least 0")
            .max(100, "Percentage must be at most 100")
            .typeError("Enter valid number");
    };
    SmartYupClass.prototype.strongPassword = function () {
        return yup.string().test({
            test: function (value) {
                return services_1.CommonLibUtils.IsStrongPassword(value);
            },
            message: "Password must be at least 12 characters long, include both uppercase and lowercase letters, and have at least one number and one special character (e.g., !, @, #, $, %, ^, &, *)."
        });
    };
    return SmartYupClass;
}());
var HSchema = /** @class */ (function () {
    function HSchema(objSchema) {
        var objYup = {};
        for (var key in objSchema) {
            var val = objSchema[key];
            if ("type" in val) {
                // let yupField = this.getYupType(val.type as any);
                var yupField = null;
                if (["number", "percentage"].includes(val.type)) {
                    yupField = yup.number().typeError("Enter valid number");
                    if (val.required) {
                    }
                }
                else if (["email", "string", "phone"].includes(val.type)) {
                    yupField = yup.string();
                }
                else if (["boolean"].includes(val.type)) {
                    yupField = yup.boolean();
                }
            }
            else {
                console.log("nest");
            }
        }
    }
    HSchema.prototype.getYupType = function (type) {
        if (["number", "percentage"].includes(type)) {
            return yup.number();
        }
        else if (["email", "string", "phone"].includes(type)) {
            return yup.string();
        }
        else if (["boolean"].includes(type)) {
            return yup.boolean();
        }
        return yup.string();
    };
    return HSchema;
}());
exports.HSchema = HSchema;
exports.smartYup = new SmartYupClass();
//# sourceMappingURL=smartYup.js.map